import { AlertService } from 's2s-app-service';
import LoggingService from 's2s-logging-service';

const alerts = (state, action)=>{

  if (typeof state === 'undefined') {
    return  { log: AlertService.getInstance().getAlertLog(),
              active: []
            };
  }

  switch (action.type) {
    case 'CLEARING_ALERT_HISTORY':
      LoggingService.getInstance().debug('ALERTS REDUCER --- CLEARING_ALERT_HISTORY');
      AlertService.getInstance().clearAlerts();
      return { ...state, log: []};

    case 'NEW_ALERT':
    {
      LoggingService.getInstance().debug('ALERTS REDUCER --- NEW_ALERT');
      // get nextId by looking at highest in state.active array and adding 1
      let nextId = Date.now();

      action.payload.alertId = nextId;

      let newActive = [].concat([action.payload], state.active).slice(0,50);  // Use "slice" to avoid mutating array.
      LoggingService.getInstance().debug('newActive', newActive)
      return {...state, active: newActive, log: AlertService.getInstance().getAlertLog()};
    }

    case 'DELETE_ALERT':
    {
      LoggingService.getInstance().debug('ALERTS REDUCER --- DELETE_ALERT');
      return {...state, log: AlertService.getInstance().getAlertLog()};
    }

    case 'DISMISS_ALERT':
    {  // filter out the active alert matching the alertId in action.payload
      //console.log('ALERTS REDUCER --- DISMISS_ALERT', AlertService.getInstance().getAlertLog())
      LoggingService.getInstance().debug('ALERTS REDUCER --- DISMISS_ALERT');
      return {...state, active: action.payload , log: AlertService.getInstance().getAlertLog()};
    }

    case 'DISMISS_PERSISTENT':
    {
      LoggingService.getInstance().debug('ALERTS REDUCER --- DISMISS_PERSISTENT')
      const remainingAlerts = state.active.filter((alertData)=>{
          return !alertData.isPersistent;
      });

      return {...state, active: remainingAlerts , log: AlertService.getInstance().getAlertLog()};
    }

    default:
    LoggingService.getInstance().debug('ALERTS REDUCER --- DEFAULT')
     return state;
    }
};

export { alerts };



// WEBPACK FOOTER //
// ./src/reducers/alerts-reducer.js